import { useQuery, useQueryClient } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { ApiRoutes } from '../api/ApiRoutes';
import { useAxios } from '../api/AxiosContext';

// const nationality = require('./nationality.json');

export const useNationalityQuery = () => {
  const axios = useAxios();

  const handleFetch = async () => {
    return axios.get<AxiosResponse<any>>(ApiRoutes.nationality);
  };

  return useQuery(['nationality'], () => handleFetch(), {
    select: (res: any) => {
      return {
        defaultValue: {
          id: res.data.defaultValue.id,
          label: res.data.defaultValue.shortName,
          value: res.data.defaultValue.name,
        },
        data: res.data.data.map((d: any) => {
          return { id: d.id, label: d.shortName, value: d.name };
        }),
      };
    },

    // keepPreviousData: true,
    cacheTime: 30000000,
    staleTime: 30000000,
  });
};

export const useNationalityCacheQuery = () => {
  const queryClient = useQueryClient();
  const cache: any = queryClient.getQueryState(['nationality']);
  if (cache?.data) {
    const cacheData = cache.data.data as any;

    return {
      defaultValue: {
        id: cacheData.defaultValue.id,
        label: cacheData.defaultValue.shortName,
        value: cacheData.defaultValue.name,
      },
      data: cacheData.data.map((d: any) => {
        return { id: d.id, label: d.shortName, value: d.name };
      }),
    };
  }
  return undefined;
};
